<template>
  <div class="spinner-overlay">
    <lottie-player
      autoplay
      loop
      :src="spinnerType"
      :style="`width:${spinnerSize}; height:${spinnerSize};`"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

type SpinnerType = "Wheel" | "Dots";

const props = withDefaults(defineProps<{ size?: string; type?: SpinnerType }>(), {
  size: "64px",
  type: "Wheel",
});
const spinnerSize = computed(() => props.size || "64px");

const spinnerType = computed(() => {
  switch (props.type) {
    case "Dots":
      return "/Lottie/lottie-loading-dots.json";
    case "Wheel":
    default:
      return "/Lottie/wheel.json";
  }
});
</script>

<style scoped lang="less">
@import (reference) "../styles/bootstrap/variables.less";

.spinner-overlay {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
